module.exports = {
    header: {
        home: '主页',
        members: '成员',
        faculty: '师资力量',
        students: '学生',
        alumni: '校友',
        project: '科研',
        publication: '论文',
        photo: '照片',

        studentMap: '毕业生',
        lang: 'English',
        dde: 'DDE',

        acemap: 'Acemap学术搜索',
        iiot: '智能物联网',
        GeoScience: '地球科学前沿交叉',
        ai: '人工智能技术',
        socialscience: '学术社会科学',
        security: '网络信息安全',

        // subTitle: '上海交通大学智能物联网研究中心',
        subTitle: 'Data Intelligence Research Center, SJTU',
        academic: '学术生活',
        spiritual: '精神风貌',
        life: '学生生活',
        courses: '课程',
        course: '课程',
        material: '教材',
        afterSchool: '课余生活',

        talk: 'DIRC TALK'
    },
    member: {
        committee: '指导委员会成员',
        leading: '主要成员',
        professor: '客座教授',
        alumni: '校友',
        scholar: '学者',
        entrepreneur: '企业家'
    },
    project: {

    },
    publication: {

    }
}